import { ApiResponse, deleteReq, getReq, postReq, putReq, UploadReq } from "../request";

/**
 * The calls Ask CRX makes, quiet: a refusal comes back to the caller instead of
 * the site's "You do not have permissions" toast or a redirect, so Ask never
 * talks about permissions (it renders nothing or falls back instead).
 */
const QUIET = { quiet: true };

export const askGet = <T = any>(url: string): Promise<ApiResponse<T>> => getReq<T>(url, QUIET);
export const askPost = <T = any>(url: string, data: any): Promise<ApiResponse<T>> => postReq<T>(url, data, QUIET);
export const askPut = <T = any>(url: string, data: any): Promise<ApiResponse<T>> => putReq<T>(url, data, QUIET);
export const askDelete = <T = any>(url: string): Promise<ApiResponse<T>> => deleteReq<T>(url, QUIET);
export const askUpload = <T = any>(url: string, data: FormData): Promise<ApiResponse<T>> => UploadReq<T>(url, data, QUIET);
